module.exports = __webpack_public_path__ + "static/media/correo.4e974d91.gif";